import script from "./RecuperarSenha.vue?vue&type=script&setup=true&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&setup=true&lang=js"

import "./RecuperarSenha.vue?vue&type=style&index=0&id=45b16f7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b16f7d"]])

export default __exports__